export default "__VITE_ASSET__99a79f05__"